<div style=" margin-top: 6.5%;display: flex;width: 100%;" [class.topDivFromReviewScreen]="navigatedFrom == 'ReviewActivity'">
    <app-jsip-left-pannel *ngIf="navigatedFrom != 'ReviewActivity'" (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen" [class.collapsedOnReviewScreen]="navigatedFrom == 'ReviewActivity'">
  <app-jsip-product-info-bar *ngIf="navigatedFrom != 'ReviewActivity'"  (productNavToggle)="selectedProductDetails = $event"></app-jsip-product-info-bar>


<div class="topDiv" style="    margin-top: 0;
    padding: 0">
    <div style="display: flex;">
    <div class="breadcrumb-bar">
  <button mat-button class="crumb home">
    <span style="    color: cornflowerblue;
    text-decoration: underline;">
    <span *ngIf="navigatedFrom == 'ReviewActivity'"  (click)="goBack()">
      Review Activities
    </span>
    <span *ngIf="navigatedFrom != 'ReviewActivity'">
      Home
    </span>
    </span>
  </button> 
 <p style="margin: 0;">/</p>
  <span class="crumb current" > 
    Alerts Summary
  </span>
</div>
 <span class="example-spacer"></span>
  <app-common-button
   *ngIf="navigatedFrom == 'ReviewActivity'"
          label="Back"
          title="Back "
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="goBack()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
 <app-common-button
   *ngIf="navigatedFrom == 'ReviewActivity'"
          label="Next"
          title="Next "
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="goToAssessment()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
</div>

    <div class="agGridOuterDiv"  style="margin-top: 0%;padding-left: 0;padding-right:0">
        <div style="margin-top: 0.5%;margin-bottom: 0.5%;display: flex;gap: 1%;">
          <div class="calendar-wrapper">
              <!-- <p-calendar 
              appendTo="body"
        [(ngModel)]="rangeDates" 
        selectionMode="range" 
        [readonlyInput]="true" 
        ></p-calendar> -->
        <mat-form-field appearance="outline" class="date-range-field">
          <!-- <mat-label>Date Range</mat-label> -->
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="rangeStartDate" (dateChange)="onDateRangeChange()" placeholder="Start date" readonly>
            <input matEndDate [(ngModel)]="rangeEndDate" (dateChange)="onDateRangeChange()" placeholder="End date" readonly>
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
    <p-select
      [options]="productOptions"
      optionLabel="label"
      placeholder="Product"
      [filter]="true"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      class="filter-dd"
      (onChange)="onProductFilter($event.value)">
    </p-select>
     <p-select
      [options]="dataSourceOptions"
      optionLabel="label"
       [filter]="true"
      placeholder="Data Source"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      class="filter-dd"
      (onChange)="onDataSourceFilter($event.value)">
    </p-select>
    <!-- <i class="pi pi-filter" style="color: slateblue"></i>
    <mat-icon class="close-icon" style="cursor: unset;">filter_list</mat-icon> -->
    <app-common-button
    
         class="AdBtn"
          label="Advance Filter"
          title="Advance Filter"
          icon="fas fa-filter"
          width="auto"
          [buttonId]="1111"
          variant="cancel"
          padding="0px 5px"
          [critical]="false"
          (click)="openAdvanceFilters()"
          >
          </app-common-button>
<span class="example-spacer"></span>
    </div>
        <div #embeddingContainer id="embeddingContainer" style="height: 73vh;"></div>

    </div>
    </div>
    </div>
    </div>